/**
 * iOS PURCHASE GATE — the only place the app asks "am I inside the native iOS app?".
 *
 * Apple requires digital subscriptions consumed in an iOS app to be sold through In-App Purchase
 * (App Store Review Guideline 3.1.1). Arvexis Pro is sold with Stripe on the web, Google Play
 * Billing on Android and StoreKit 2 on iPhone (utils/iosBilling.js). The native iOS build must never
 * open Stripe Checkout inside itself, so this gate stays as the backstop for every checkout caller.
 */

import { Capacitor } from '@capacitor/core';

export const isIosApp = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';

/** What members see instead. Intentionally NOT an actionable link: a link-out carries its own
 *  App Store rules, so the native build simply says where to go. */
export const iosPurchaseNotice = (lang) =>
  lang === 'es'
    ? 'Tu suscripción de Arvexis se gestiona en arvexisapp.com desde un navegador.'
    : 'Your Arvexis subscription is managed at arvexisapp.com in a browser.';
